"use client"
import BaseLoginList from "../BaseLoginList/BaseLoginList"

export default function BaseLoginContainer() {
  return <BaseLoginList />
}
